import { ButtonPosition, ALL_BUTTON_POSITION_LIST, } from '@/common/manager/position/button-position';
import { getRealizeValue, calculateTextExprValue } from '@/common/util/util';
import { DisplayPosition } from '../../position/display-position';
import { __arrayTableCurrentRow__ } from '@/common/util/expr-const';
import { handleRequestParams } from '@/common/util/request';
import qs from 'query-string';
export const config = {
    value: 'link',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config, extra) => {
        const { buttonConfig, urlParamsDataSource, recordDataSource: originalRecordDataSource, state, position, arrayTableConfig, selectedRowKeys = [], selectedRowRecords = [], getExtraParam, arrayTableCurrentRow, arrayBaseFieldIndex, parentPosition, } = config;
        const needDelay = position === ButtonPosition.formDialogSubmitAfterRequestSuccess ||
            position === ButtonPosition.formSubmitAfterRequestSuccess;
        const { options } = buttonConfig || {};
        let extraParamList = [];
        let recordDataSource = getRealizeValue(originalRecordDataSource);
        if (position === ButtonPosition.arraySubAreaCardOperate) {
            recordDataSource = arrayTableCurrentRow;
            extraParamList = [arrayBaseFieldIndex];
        }
        else if (position === ButtonPosition.arrayTableOperate) {
            if (extra?.field) {
                const { field } = extra;
                const { formItemConfig } = arrayTableConfig || {};
                if (formItemConfig?.name && field) {
                    const list = field?.query?.(formItemConfig?.name)?.value?.();
                    if (Array.isArray(list) && list[field?.index]) {
                        recordDataSource = list[field.index];
                        extraParamList = [field.index];
                    }
                }
            }
        }
        else if (position === ButtonPosition.arrayTableCell) {
            const { field } = extra || {};
            if (field) {
                const index = +field?.path?.segments?.[1];
                if (typeof index === 'number' && !isNaN(index)) {
                    recordDataSource = field.query('..').value()?.[index];
                    extraParamList = [index];
                }
            }
        }
        else {
            extraParamList.push(selectedRowKeys);
            extraParamList.push(selectedRowRecords);
        }
        if (position === ButtonPosition.subCardAction &&
            parentPosition === DisplayPosition.cnArraySubAreaCard) {
            extraParamList = [
                {
                    [__arrayTableCurrentRow__]: arrayTableCurrentRow,
                },
            ];
        }
        if (options) {
            const { url, redirectType, urlParams = [] } = options;
            let search = '';
            if (redirectType === 'back') {
                window?.history?.back?.();
            }
            else {
                if (urlParams && urlParams.length > 0) {
                    const temp = handleRequestParams(urlParams, {
                        urlParamsDataSource,
                        recordDataSource,
                        state,
                        extraParamList,
                        getExtraParam,
                    });
                    search = qs.stringify(temp);
                }
                if (url) {
                    let realUrl = calculateTextExprValue(url, {
                        urlParamsDataSource,
                        recordDataSource,
                        state,
                        extraParamList,
                        getExtraParam,
                    });
                    if (typeof realUrl === 'string' && realUrl.length > 0) {
                        if (realUrl.indexOf('?') !== -1) {
                            if (search) {
                                realUrl += `&${search}`;
                            }
                        }
                        else if (search) {
                            realUrl += `?${search}`;
                        }
                        const temp = () => {
                            if (redirectType === 'current') {
                                if (typeof window.jumpTo === 'function') {
                                    const tempList = realUrl?.split('?');
                                    window.jumpTo({
                                        pathname: tempList?.[0],
                                        search: tempList?.[1],
                                        reload: true,
                                    });
                                }
                                else {
                                    location.href = realUrl;
                                }
                            }
                            else if (redirectType === 'open') {
                                if (typeof window.jumpTo === 'function') {
                                    const tempList = realUrl?.split('?');
                                    window.jumpTo({
                                        pathname: tempList?.[0],
                                        search: tempList?.[1],
                                        type: '_blank',
                                    });
                                }
                                else {
                                    window.open(realUrl);
                                }
                            }
                        };
                        if (needDelay) {
                            setTimeout(temp, 1500);
                        }
                        else {
                            temp();
                        }
                    }
                }
            }
        }
    },
};
